// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.alpha-u.wallet.web",
    name: "αU wallet",
    homepage: "https://web.wallet.alpha-u.io/intro.html",
    image_id: "40489ba1-6eb0-49a1-a9d4-439fefe52000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/jp/app/%CE%B1u-wallet/id6444401106",
        android: "https://play.google.com/store/apps/details?id=com.kddi.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: "nothing",
        firefox: "nothing",
        safari: "nothing",
        edge: "nothing",
        opera: "nothing",
    },
    rdns: null,
    mobile: {
        native: "alpha-u-wallet://",
        universal: "https://alphauwallet.page.link/?apn=com.kddi.wallet&ibi=com.kddi.wallet&isi=6444401106&link=https://web.wallet.alpha-u.io/intro.html",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map